<ion-item (click)="open()" >
  <ion-input style="cursor: pointer" readonly="true" label-placement="floating" label="Local"
             [value]="local?.nome"/>
  <ion-buttons  slot="end">
    <ion-icon  name="caret-down-outline"/>
  </ion-buttons>

</ion-item>

<ion-modal [isOpen]="isLocalOpen">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Selecione o Local</ion-title>
        <ion-buttons slot="start">
          <ion-button (click)="voltar()">
            <ion-icon name="arrow-back-outline"/>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-icon (click)="close()" color="success" size="large" name="checkmark"/>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <p-tree  [value]="nos" selectionMode="single"
               [(selection)]="selecao">
      </p-tree>
    </ion-content>
  </ng-template>
</ion-modal>
